import BlockComponentMap from '../../../models/BlockComponentValues/BlockComponentMap';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockHtmlData {
  html: BlockComponentMap;
  title?: BlockComponentText;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockHtmlData {
  export function make(html?: string, title?: string, url?: string): BlockHtmlData {
    return {
      html: BlockComponentMap.make(html),
      title: BlockComponentText.make(title),
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(html: string = undefined, title = 'HTMLページタイトル'): BlockHtmlData {
    return make(
      html,
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
    );
  }
}

export default BlockHtmlData;
